module.exports = __webpack_public_path__ + "img/Zadeh.0acb6718.png";